import React, { useState, useRef, useEffect } from "react";
import { GoogleMap, Marker } from "@react-google-maps/api";
// import { useDarkTheme } from "../../theme";

const defaultLocation = {
  lat: 37.0902,
  lng: -95.7129
}

// const options = { styles: useDarkTheme ? dark : [] };
const options = {
  gestureHandling: 'greedy',
  cameraControl: false,
  zoomControl: true
};

function Map({ pin = defaultLocation, isManuallyAdded, details, setDetails }) {
  const mapRef = useRef(null);
  const [markerPosition, setMarkerPosition] = useState(null);
  useEffect(() => {
    if (!details?.location) return;
    setMarkerPosition({
      lat: details.location.lat,
      lng: details.location.lng
    });
    if (mapRef?.current) {
      mapRef.current.panTo(new window.google.maps.LatLng(details.location.lat, details.location.lng));
      mapRef.current.setZoom(17);
    }
  }, [details]);
  const setLocation = (coord) => {
    const { latLng } = coord;
    const lat = latLng.lat();
    const lng = latLng.lng();
    setDetails({
      ...details,
      location: {
        lat: lat,
        lng: lng
      }
    });
    setMarkerPosition({ lat: lat, lng: lng })
  }
  const onMarkerDragEnd = (coord) => {
    setLocation(coord);
  };
  const handleMapOnClick = (coord) => {
    if (markerPosition == null) {
      setLocation(coord);
    }
  }
  const onLoad = React.useCallback(map => {
    mapRef.current = map;
    if (!details?.location) return;
    mapRef.current.panTo(new window.google.maps.LatLng(details.location.lat, details.location.lng));
    mapRef.current.setZoom(17);
  }, [details])
  return (
    <GoogleMap
      onLoad={onLoad}
      zoom={4}
      center={pin}
      mapContainerStyle={{ height: 250, flexGrow: 1 }}
      options={options}
      onClick={handleMapOnClick}
    >
      {markerPosition &&
        <Marker
          position={markerPosition}
          draggable={isManuallyAdded}
          onDragEnd={(coord) => onMarkerDragEnd(coord)}
        />
      }
    </GoogleMap>
  )
}

export default Map;